import axios from 'axios';
import authState from '@/store/auth';
import HexabaseApi from '@/services/hexabase/hexabaseApi';

export default class Simwork {
  private hexabaseApi = new HexabaseApi();

  private createFormConfig = {
    headers: {
      'Content-type': 'application/json',
    }
  };

  async triggerGetDoc(
    param: any,
    header?: { [k: string]: { [k: string]: string } }
   ) {
    try {
      if (header === undefined || header === null) header = this.createFormConfig;
      const config = JSON.parse(JSON.stringify(header));
      param['temp_token'] = authState.token;
      const apiResult= await axios.post(
        `/simwork-api/http_trigger_get_doc`,
        JSON.stringify(param),
        config
      );
      return apiResult;
    } catch (error) {
      return this.setSimWorkApiErrorMessage(error, 'triggerGetDoc')
    }
  }


  // http_trigger_get_doc_status
  async triggerGetDocStatus(
    param: any,
    header?: { [k: string]: { [k: string]: string } }
   ) {
    try {
      if (header === undefined || header === null) header = this.createFormConfig;
      const config = JSON.parse(JSON.stringify(header));
      param['temp_token'] = authState.token;

      return await axios.post(
        `/simwork-api/http_trigger_get_doc_status`,
        JSON.stringify(param),
        config
      );
    } catch (error) {
      return this.setSimWorkApiErrorMessage(error, 'triggerGetDocStatus')
    }
  }

  async triggerRegisterDocumentSign(
    param: any,
    header?: { [k: string]: { [k: string]: string } }
   ) {
    try {
      if (header === undefined || header === null) header = this.createFormConfig;
      const config = JSON.parse(JSON.stringify(header));  
      param['temp_token'] = authState.token;

      return await axios.post(
        `/simwork-api/http_trigger_register_document_sign`,
        JSON.stringify(param),
        config
      );
    } catch (error) {
      return this.setSimWorkApiErrorMessage(error, 'triggerRegisterDocumentSign')
    }
  }

  private setSimWorkApiErrorMessage(error: any, apiName: string) {
    const errorMessageData:any = error;
    let replaceStr:any = {}
    if (errorMessageData !== undefined) {
      const str = String(errorMessageData.response.data);
      try {
        replaceStr = JSON.parse(str.replace(/'/g,'"'));
        return { data: replaceStr, apiName: apiName, error: true }
      } catch (e) {
        return { data: str, apiName: apiName, error: true }
      }
    } else {
      return { data: error.message, apiName: apiName, error: true }
    }
  }
}